import { StyledSvg } from "baseui/icon";
import React from "react";

export const PlusIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg viewBox="0 0 16 16" {...props}>
    <path d="M8.78571 8.78571H12.7143C13.1488 8.78571 13.5 8.43371 13.5 8C13.5 7.56629 13.1488 7.21429 12.7143 7.21429H8.78571V3.28571C8.78571 2.852 8.4345 2.5 8 2.5C7.5655 2.5 7.21429 2.852 7.21429 3.28571V7.21429H3.28571C2.85121 7.21429 2.5 7.56629 2.5 8C2.5 8.43371 2.85121 8.78571 3.28571 8.78571H7.21429V12.7143C7.21429 13.148 7.5655 13.5 8 13.5C8.4345 13.5 8.78571 13.148 8.78571 12.7143V8.78571Z" />
  </StyledSvg>
);
